import type { JSX } from 'react';
import type { ExternalReferralContentKeys } from '@common/validation/customControls/externalReferral';
import type { HearingLossAudiologistConsultDataBase } from '@common/validation/customControls/hearingLoss/hearingLossAudiologistConsultDataBase';
import type { ContentComponentsMap } from '@frontend/formEngine/editForm/editForm.types';
import { ProcessActivityReadContext } from '@frontend/components/pages/episodeCategory/carePath/process/processActivity/processActivityRead/processActivityReadContext';
import { ReadForm } from '@frontend/formEngine/readForm/ReadForm';
import { useDefinedContext } from '@frontend/utils/hooks/useDefinedContext';
import { HearingLossAudiologistConsultBijgevoegdeInformatie } from './HearingLossAudiologistConsultBijgevoegdeInformatie';

export function HearingLossAudiologistConsultRead({
    isFollowUp = false,
}: Readonly<{ isFollowUp?: boolean }>): JSX.Element {
    const {
        processActivity: { customControlData },
    } = useDefinedContext(ProcessActivityReadContext);

    return <ReadForm components={getContentComponents(customControlData, isFollowUp)} />;
}

export function getContentComponents(
    customControlData: HearingLossAudiologistConsultDataBase,
    isFollowUp: boolean
): ContentComponentsMap<ExternalReferralContentKeys> {
    const map: ContentComponentsMap<ExternalReferralContentKeys> = new Map();

    if (customControlData.verwijzing_specialist_nodig) {
        map.set(
            'bijgevoegde_informatie',
            <HearingLossAudiologistConsultBijgevoegdeInformatie isFollowUp={isFollowUp} />
        );
    }

    return map;
}
